export const LABORATORY_MESSAGES = {
	NO_REGISTRATION_ESSILOR: "Sua ótica ainda não tem cadastro ativo em nenhum laboratório Essilor.",
	NO_REGISTRATION_COMPANY: "Sua Empresa ainda não tem cadastro ativo em nenhum laboratório Essilor habilitado.",
	CONFIGURE_PREFERRED_LABS: "Para configurar seus laboratórios Essilor preferenciais,",
	SELECT_PREFERRED_LABS: "Selecione os laboratórios Essilor de preferência",
};

const MESSAGES = {
	CANNOT_CREATE_LINK: 'Não foi possível criar um vínculo com a empresa',
	CNPJ_NOT_FOUND: 'Não encontramos seu CNPJ em nossa base. Por favor, entre em contato pelo e-mail duvidas@essilorpromo.com.br',
	CNPJ_PENDING: 'Este CNPJ está com alguma pendência no Referencial Essilor. Para que seja realizado o ajuste, favor entrar em contato com o suporte através da Ferramenta',
	CNPJ_INVALID: 'Este CNPJ é inválido.',
	COMPANY_ADDED: 'Empresa adicionada com sucesso!',
	LINK_CREATION_FAILED: 'Não foi possível criar um vínculo com essa empresa. Favor entrar em contato com o suporte...',
	CUSTOMER_PENDING_IN_LAB: 'Existe uma pendência no cadastro do cliente {cnpj} no laboratório.',
	NEW_OPTICAL_USER: "Solicite a alteração do seu perfil de acesso entrando em contato com seu Consultor Essilor ou com um laboratório de sua preferência, informando seu <b>CNPJ</b> e <b>e-mail de cadastro</b> no Essilor Conecta",
	NO_ACCOUNT: 'Ainda não tem uma conta?',
	REGISTRATION_DOUBTS: 'Ficou com dúvidas no cadastro?',

	// Mídia LABs
	MIDIA_LABS_CHOOSE_TITLE: 'Escolha seu laboratório próprio Essilor.',
	MIDIA_LABS_CHOOSE_SUBTITLE: 'Selecione o laboratório para visualizar as mídias disponíveis.',
	MIDIA_LABS_NO_LABS: 'Nenhum laboratório disponível no momento.',
	MIDIA_LABS_DESCRIPTION: 'Agora você pode fazer download ou compartilhar as campanhas, promoções e produtos Essilor direto aqui do Mídia Labs. E mais: você ainda pode incluir sua logo e customizar algumas postagens!',
	MIDIA_LABS_CLICK_TO_ADD: 'Clique aqui para adicionar arquivos',
	MIDIA_LABS_NO_MEDIA: 'Nenhuma mídia disponível no momento.',
	MIDIA_LABS_BACK_TO_LABS: '← Voltar para escolha de laboratório',

	// MidiaLabsForm
	MIDIA_LABS_FORM_ERROR: 'Erro',
	MIDIA_LABS_FORM_THUMBNAIL_ERROR: 'Thumbnail deve ser uma imagem',
	MIDIA_LABS_FORM_NAME_REQUIRED: 'Nome da peça é obrigatório',
	MIDIA_LABS_FORM_THUMBNAIL_REQUIRED: 'Thumbnail é obrigatório',
	MIDIA_LABS_FORM_FILE_OR_LINK_REQUIRED: 'É necessário fornecer um arquivo ou um link',
	MIDIA_LABS_FORM_LINK_OR_FILE_REQUIRED: 'É necessário fornecer um link ou um arquivo',
	MIDIA_LABS_FORM_INVALID_URL: 'Por favor, insira um link válido (https://)',
	MIDIA_LABS_FORM_UPDATING: 'Atualizando mídia...',
	MIDIA_LABS_FORM_SAVING: 'Salvando mídia...',
	MIDIA_LABS_FORM_SUCCESS: 'Sucesso!',
	MIDIA_LABS_FORM_ERROR_SAVING: 'Erro ao salvar mídia',
	MIDIA_LABS_FORM_EDIT_TITLE: 'Editar mídia',
	MIDIA_LABS_FORM_CREATE_TITLE: 'Nova mídia',
	MIDIA_LABS_FORM_INFO_SECTION: 'Informações da peça',
	MIDIA_LABS_FORM_NAME_LABEL: 'Nome da peça*',
	MIDIA_LABS_FORM_LINK_LABEL: 'Link',
	MIDIA_LABS_FORM_LINK_ARIA: 'Link externo',
	MIDIA_LABS_FORM_LINK_TOOLTIP: 'Página para a qual o usuário será redirecionado ao clicar em Acessar',
	MIDIA_LABS_FORM_FILES_SECTION: 'Arquivos',
	MIDIA_LABS_FORM_THUMBNAIL_LABEL: 'Thumbnail da peça*',
	MIDIA_LABS_FORM_FILE_LOADED: 'Arquivo carregado',
	MIDIA_LABS_FORM_DRAG_OR_CLICK: 'Arraste o arquivo ou clique aqui para selecionar',
	MIDIA_LABS_FORM_FILE_LABEL: 'Arquivo da peça',
	MIDIA_LABS_FORM_CANCEL: 'Cancelar',
	MIDIA_LABS_FORM_SAVE: 'Salvar',
	MIDIA_LABS_FORM_SAVING_BUTTON: 'Salvando...',

	// Lente Pronta
	LENTE_PRONTA_CHOOSE_TITLE: 'Escolha seu laboratório próprio Essilor.',
	LENTE_PRONTA_CHOOSE_SUBTITLE: 'Escolha um dos seguintes laboratórios próprios da Essilor para realizar seu pedido.',
	LENTE_PRONTA_NO_LABS: 'Nenhum laboratório disponível para Lente Pronta no momento.',
	LENTE_PRONTA_ALERT_TEXT: 'Para pedidos de lentes prontas sem serviços utilize o módulo Conecta Lente Pronta.',
	LENTE_PRONTA_ALERT_LINK: 'Ir para o Conecta Lente Pronta',
	ATACADO_ALERT_TEXT: 'Para pedidos de lentes prontas sem serviços utilize o módulo Conecta Atacado.',
	ATACADO_ALERT_LINK: 'Ir para o Conecta Atacado',
	PEDIDOS_ALERT_TEXT: 'Para pedidos de lentes prontas com serviços, utilize o módulo Conecta Pedidos.',
	PEDIDOS_ALERT_LINK: 'Ir para o Conecta Pedidos',

	// Voucher Pacto
	VOUCHER_PACTO_TITLE: 'Voucher Pacto',
	VOUCHER_PACTO_DESCRIPTION: 'Caso possua um Voucher Pacto, insira o código no campo abaixo.',
	VOUCHER_PACTO_LABEL: 'Voucher Pacto',
	VOUCHER_PACTO_ARIA: 'Campo para inserir código do Voucher Pacto',
	VOUCHER_PACTO_LINK_TEXT: 'Confira mais detalhes dos seus vouchers acessando o ',
	VOUCHER_PACTO_LINK_LABEL: 'Programa Pacto',

	// Pacto Rebates
	FILTRAR_RESULTADOS: 'Filtrar Resultados',
};

export default MESSAGES;